import { render } from "./SnackbarBar.vue?vue&type=template&id=644bab68"
import script from "./SnackbarBar.vue?vue&type=script&lang=js"
export * from "./SnackbarBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__